// src/utils/particle.js
// 한국어 조사(particle) 헬퍼 — 받침 유무에 따라 올바른 조사 선택

function hasBatchim(name) {
  if (!name) return false;
  const last = name.charCodeAt(name.length - 1);
  if (last < 0xAC00 || last > 0xD7A3) return false;
  return (last - 0xAC00) % 28 !== 0;
}

/** 이/가 → "나비가", "보리가" (받침 없으면 가, 있으면 이가) */
export function subjectParticle(name, fallback = "친구가") {
  if (!name) return fallback;
  return hasBatchim(name) ? `${name}이가` : `${name}가`;
}

/** 이야/야 → "나비야", "보리야" */
export function iyaParticle(name) {
  if (!name) return "친구야";
  return hasBatchim(name) ? `${name}이야` : `${name}야`;
}

/** 이/가 (주격) → "나비가", "콩이" */
export function gaParticle(name) {
  if (!name) return "친구가";
  return hasBatchim(name) ? `${name}이` : `${name}가`;
}

/** 을/를 → "나비를", "콩을" */
export function objectParticle(name) {
  if (!name) return "친구를";
  return hasBatchim(name) ? `${name}을` : `${name}를`;
}

/** 은/는 → "나비는", "콩은" */
export function topicParticle(name) {
  if (!name) return "친구는";
  return hasBatchim(name) ? `${name}은` : `${name}는`;
}

/** 아/야 (호격) → "나비야", "콩아" */
export function vocativeParticle(name) {
  if (!name) return "친구야";
  return hasBatchim(name) ? `${name}아` : `${name}야`;
}
